module.exports = __webpack_public_path__ + "resources/DeviceTouch-329551f99123a8e6ca19768c9894b13a.png";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/DeviceTouch.png
// module id = 76
// module chunks = 0